// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__3oj__","assignButton":"CreateEditEquipmentSchedule_assignButton__1tIfK"};